import {AttachmentInfoApiDto} from "./restModels";

export class AttachmentInfo {
	constructor(public readonly id: string,) {
	}

	public static fromJson(json: AttachmentInfoApiDto): AttachmentInfo {
		return new AttachmentInfo(json.id);
	}
}